import request from './request';

const API_PREFIX = '/v2/clubs';

// === 服务器授时基准 ===
export const getServerTime = () => {
  return request.get(`${API_PREFIX}/server-time`);
};

// === 社团列表 ===
export const getClubs = (params) => {
  return request.get(`${API_PREFIX}/`, { params });
};

// === 报名批次 ===
export const getSessions = (params) => {
  return request.get(`${API_PREFIX}/sessions/`, { params });
};

export const getSessionDetail = (id) => {
  return request.get(`${API_PREFIX}/sessions/${id}/`);
};

export const updateSession = (id, data) => {
  return request.put(`${API_PREFIX}/sessions/${id}/`, data);
};

export const createSession = (data) => {
  return request.post(`${API_PREFIX}/sessions/`, data);
};

export const toggleSessionStatus = (id) => {
  return request.post(`${API_PREFIX}/sessions/${id}/toggle/`);
};

export const deleteSession = (id) => {
  return request.delete(`${API_PREFIX}/sessions/${id}/`);
};

// === 社团详情与管理 ===
export const getClubDetail = (id) => {
  return request.get(`${API_PREFIX}/${id}/`);
};

export const createClub = (data) => {
  return request.post(`${API_PREFIX}/`, data);
};

export const updateClub = (id, data) => {
  return request.put(`${API_PREFIX}/${id}/`, data);
};

export const deleteClub = (id) => {
  return request.delete(`${API_PREFIX}/${id}/`);
};

// === 报名操作 ===
export const registerForClub = (data) => {
  return request.post(`${API_PREFIX}/registrations/`, data);
};

export const cancelRegistration = (id) => {
  return request.delete(`${API_PREFIX}/registrations/${id}`);
};

// === 我的报名 ===
export const getMyRegistrations = (params) => {
  return request.get(`${API_PREFIX}/registrations/my/`, { params });
};

// === 教师管理端接口 ===
// 获取某个批次的报名名单 (用于点名)
export const getRegistrations = (params) => {
    return request.get(`${API_PREFIX}/registrations/`, { params });
};

// 提交点名
export const takeAttendance = (data) => {
    return request.post(`${API_PREFIX}/attendance/`, data);
};

// 获取点名历史
export const getAttendanceHistory = (sessionId) => {
    return request.get(`${API_PREFIX}/attendance/history/${sessionId}/`);
};

// === 请假审核接口 ===
// 获取待审核请假列表
export const getAllLeaveRequests = (params) => {
    return request.get(`${API_PREFIX}/leave/`, { params });
};

// 获取待审核请假统计 (用于角标)
export const getPendingLeaveCounts = () => {
    return request.get(`${API_PREFIX}/leave/pending-counts/`);
};

// 审核请假
export const reviewLeaveRequest = (id, data) => {
    return request.post(`${API_PREFIX}/leave/${id}/review/`, data);
};

// === 广播通知接口 ===
// 发布通知
export const createNotification = (data) => {
    return request.post(`${API_PREFIX}/broadcast/`, data);
};

// 获取通知列表
export const getNotifications = (sessionId) => {
    return request.get(`${API_PREFIX}/broadcast/${sessionId}/`);
};

// 删除通知
export const deleteNotification = (id) => {
    return request.delete(`${API_PREFIX}/broadcast/${id}/`);
};

// === 活动相册接口 ===
// 上传照片文件
export const uploadActivityPhoto = (formData) => {
    return request.post(`${API_PREFIX}/album/upload/`, formData);
};

// 保存照片记录
export const addPhotoRecord = (data) => {
    return request.post(`${API_PREFIX}/album`, data);
};

// 获取相册列表
export const getAlbum = async (sessionId) => {
    const res = await request.get(`${API_PREFIX}/album/${sessionId}/`);
    // 重写历史数据的 URL，避免 Nginx 对 .jpg/.png 进行静态文件拦截导致 404
    if (Array.isArray(res)) {
        return res.map(photo => {
            if (photo.image_url && photo.image_url.includes('/view/')) {
                const parts = photo.image_url.split('/view/');
                if (parts.length === 2) {
                    photo.image_url = `${parts[0]}/view_image?file=${parts[1]}`;
                }
            }
            return photo;
        });
    }
    return res;
};

// 删除照片
export const deletePhoto = (id) => {
    return request.delete(`${API_PREFIX}/album/${id}/`);
};

// === 评价接口 ===
// 提交评价
export const createEvaluation = (data) => {
    return request.post(`${API_PREFIX}/evaluation/`, data);
};

// 获取学生评价历史
export const getStudentEvaluations = (studentId, sessionId) => {
    return request.get(`${API_PREFIX}/evaluation/student/${studentId}/`, { 
        params: { session_id: sessionId } 
    });
};

// 回复评价
export const replyToEvaluation = (id, replyText) => {
    return request.post(`${API_PREFIX}/evaluation/${id}/reply/`, { student_reply: replyText });
};

// === 考勤与请假 (学生端) ===
// 获取学生考勤
export const getStudentAttendance = (studentId, sessionId) => {
    return request.get(`${API_PREFIX}/attendance/student/${studentId}/`, {
        params: { session_id: sessionId }
    });
};

// 提交请假申请
export const applyForLeave = (data) => {
    return request.post(`${API_PREFIX}/leave/`, data);
};

// 获取我的请假历史
export const getMyLeaveRequests = () => {
    return request.get(`${API_PREFIX}/leave/my/`);
};

// === 统计接口 ===
export const getClubStatistics = (params) => {
    return request.get(`${API_PREFIX}/statistics/`, { params });
};
